export default __webpack_public_path__ + "static/72-966b32d4e3add0692546809ef036375f.gif";